/* @flow */

import { errorColor, successColor } from '@e180/ui/lib/token/color';
import { white } from '@e180/ui/lib/token/palette';

export default {
  root: {
    display: 'inline-block',

    padding: '0.25em 0.5em',

    color: white,

    fontSize: '0.8125rem',
    fontWeight: 500,
    WebkitFontSmoothing: 'antialiased',
  },
  'root-error': {
    color: errorColor,
  },
  'root-maxValue': {
    color: successColor,
  },
};
